const element = document.createElement('div')

export default element.style
